import React, { Fragment, useEffect, useState, useMemo } from "react";
import { CCollapse, CLink } from "@coreui/react";
import axios from "axios";
import config from "../../config/config";
import { toastSuccess, toastError } from "../../common/Toast";
import { Noimage } from "../../common/imagePath";
import DeleteConfirmationModalBanner from "../Modal/DeleteConfirmation";
import { Box, Button, IconButton, MenuItem, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CommonMatrialReactTable from "../Datatable/CommonMatrialReactTable";

function FeaturedProducts(props) {
  const [visibleFeaturedProducts, setVisibleFeaturedProducts] = useState(false);
  const token = localStorage.getItem("Token");
  const [products, setProducts] = useState(props.visibleProductChange);

  const [data, setdata] = useState([]);

  const [dynamicValue, setDynamicValue] = useState("MainSite");

  useEffect(() => {
    if (props?.dynamicModule) {
      setDynamicValue(props.dynamicModule);
    }
  }, [props?.dynamicModule]);

  // CALLBACK

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [data11, setdata11] = useState(true);

  const callback = (payload) => {
    fetchApi();
  };

  const fetchApi = () => {
    axios
      .get(
        `${config.ecommconfigBaseUrl}/ecomconfig/getfeaturedproducts?from=${dynamicValue}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setdata(res.data.ResponseID);
        return res;
      });
  };

  //UseEffect For Table
  useEffect(() => {
    fetchApi();
  }, [dynamicValue]);

  const columns = useMemo(() => [
    {
      header: "Item ID",
      accessorKey: "ItemID",
      size: "20",
    },
    {
      header: "Item Name",
      accessorKey: "ItemName",
    },
    {
      header: "Variation Name",
      accessorKey: "VariationName",
    },
    {
      header: "Quantity",
      accessorKey: "Quantity",
      Cell: ({ row }) => {
        return parseFloat(row.original.Quantity).toFixed(2);
      },
    },
    {
      header: "Unit Price",
      accessorKey: "UnitPrice",
      Cell: ({ row }) => {
        return parseFloat(row.original.UnitPrice).toFixed(2);
      },
    },
    {
      header: "Cost Price",
      accessorKey: "CostPrice",
      size: "150",
      Cell: ({ row }) => {
        return parseFloat(row.original.CostPrice).toFixed(2);
      },
    },
  ]);

  const openDeleteFunction = (row) => {
    const deleteRequestParam = {
      ID: row.original.ItemID,
      module: "featureproduct",
      from : dynamicValue
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );

    setDeleteModalOpen(true);
  };

  const muiRowDragHandleProps = ({ table }) => ({
    onDragEnd: () => {
      const { draggingRow, hoveredRow } = table.getState();
      if (hoveredRow && draggingRow) {
        data.splice(hoveredRow.index, 0, data.splice(draggingRow.index, 1)[0]);
        setdata([...data]);
      }
    },
  });

  const handelSaveRowOrder = () => {
    const categoryIdList = data.map((el) => el.ItemID).join(",");
    const finalData = {
      ids: categoryIdList,
      model: "Products",
      type: "FeaturedProducts",
    };

    axios
      .post(`${config.ecommconfigBaseUrl}/ecomconfig/setRowOrder`, finalData, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        toastSuccess("Category Row Order Successfully Done");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <Fragment>
        <div className="card">
          <div className="card-header">
            <h5 className="card-title">
              <CLink
                className="link"
                onClick={() => {
                  setVisibleFeaturedProducts(!visibleFeaturedProducts);
                  setProducts(!!products);
                }}
              >
                Featured Products
              </CLink>
            </h5>
          </div>
          <CCollapse
            visible={visibleFeaturedProducts || props.visibleProductChange}
          >
            <div class="card-body">
              <div className="row">
                <div class="col-6">
                  <SearchableDropdown
                    callback={callback}
                    dynamicValue={dynamicValue}
                  />
                </div>
                <div className="col-6 d-flex justify-content-end align-items-start">
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => handelSaveRowOrder()}
                    style={{ margin: "6px" }}
                  >
                    Save Row Order
                  </button>
                </div>
              </div>
              <div
                className="table-responsive  mt-4"
                style={{ border: "1px solid rgba(0,0,0,.12)" }}
              >
                <CommonMatrialReactTable
                  columns={columns}
                  data={data}
                  hodiExport={true}
                  enableRowSelection={false}
                  enableRowOrdering={true}
                  muiRowDragHandleProps={muiRowDragHandleProps}
                  enableRowActions={true}
                  renderRowActions={({ row }) => (
                    <Box>
                      <IconButton onClick={() => openDeleteFunction(row)}>
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  )}
                  // renderRowActionMenuItems={({ row }) => [
                  //   <MenuItem
                  //     className="confirm-text"
                  //     to="#"
                  //     // key="delete"
                  //     title="Delete"
                  //     data-bs-toggle="modal"
                  //     // data-bs-target="#DeleteConfirmationModal"
                  //     onClick={() => openDeleteFunction(row)}
                  //   >
                  //     <DeleteIcon />
                  //     Delete
                  //   </MenuItem>,
                  // ]}
                />
              </div>
            </div>
          </CCollapse>
        </div>
        <DeleteConfirmationModalBanner
          deleteApiUrl={`${config.ecommconfigBaseUrl}/ecomconfig/deleteproducts`}
          open={deleteModalOpen}
          data11={data11}
          onClose={() => {
            setDeleteModalOpen(false);
            fetchApi();
          }}
          dynamicValue={dynamicValue}
          // module="featureproduct"
        />
      </Fragment>
    </>
  );
}

// SearchableDropdown
const SearchableDropdown = ({ callback, dynamicValue }) => {
  const token = localStorage.getItem("Token");
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [cursor, setcursor] = useState(0);
  const [tableData, setTableData] = useState([]);

  const [selectedOption, setSelectedOption] = useState(null);

  // const state = {
  //   example: "Hello",
  // };

  // const handleCallback = () => callback({ A: "hello" });

  const fetchData = async (inputValue) => {
    if (inputValue != "") {
      axios
        .get(
          `${config.itemsBaseUrl}/items/searchitem?searchparam=${inputValue}&from=${dynamicValue}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          if (response != "" && response != null) {
            const data = response.data.ResponseData;
            if (data[0].ItemId > 0) {
              setSuggestions(data);
            } else {
              setSuggestions([]);
            }
          }
        })
        .catch((error) => {});
    } else {
      setSuggestions([]);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      fetchData(inputValue);
    }, 500);
  }, [inputValue]);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);

    if (!value) {
      setSuggestions([]);
    }
  };

  const handleInputClick = (
    pItemId,
    pItemName,
    pDescription,
    pVariationId,
    pAttributeId,
    pUnitPrice,
    pCostPrice,
    pQuantity,
    pVariationName
  ) => {
    const selectedOption = {
      ItemID: pItemId,
      ItemName: pItemName,
      Description: pDescription,
      VariationID: pVariationId,
      Quantity: pQuantity,
      AttributeId: pAttributeId,
      UnitPrice: pUnitPrice,
      CostPrice: pCostPrice,
      VariationName: pVariationName,
    };

    const data = {
      FeaturedProducts: String(pItemId),
      from: dynamicValue,
    };

    axios
      .post(`${config.ecommconfigBaseUrl}/ecomconfig/featuredproducts`, data, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        toastSuccess("Featured Product Add Successfully Done");
        callback(selectedOption);
        setInputValue("");
        setSuggestions([]);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="container">
      <form>
        <div className="mb-3" style={{ width: "400px" }}>
          {/* <input type="text" className="form-control" value={inputValue} onChange={handleInputChange} /> */}
          <div className="input-group flex-nowrap">
            <span className="input-group-text" id="addon-wrapping">
              <i
                class="fa fa-edit fs-3"
                style={{ color: "var(--secondary-main-color)" }}
              ></i>
            </span>

            <input
              type="text"
              className="form-control h-auto"
              placeholder="Type item name or scan barcode"
              value={inputValue}
              onChange={handleInputChange}
            />
          </div>
        </div>
        {suggestions.length > 0 ? (
          <div
            className="dropdown"
            style={{ position: "relative", width: "400px" }}
          >
            <ul
              className="dropdown-menu  show" //dropdown-suggestion
              style={{
                //  width: "100%",
                maxHeight: "400px",
                overflowY: "auto",
              }}
            >
              {suggestions.map((item, index) => (
                <li
                  key={item.ItemId}
                  style={{ cursor: "pointer" }}
                  className={"dropdown-item"}
                  onClick={(e) =>
                    handleInputClick(
                      item.ItemId,
                      item.ItemName,
                      item.Description,
                      item.VariationId,
                      item.AttributeId,
                      item.UnitPrice,
                      item.CostPrice,
                      item.itemquantity,
                      item.VariationName
                    )
                  }
                >
                  <a
                    key={item.ItemId}
                    className={"dropdown-item"}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={item.images ? item.images : Noimage}
                      alt={item.ItemName}
                      className="img-thumbnail rounded-circle mr-5"
                      style={{
                        maxWidth: "55px",
                        maxHeight: "55px",
                      }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = Noimage;
                      }}
                    />
                    <div className="customer-info ml-2">
                      <h6 className="name">
                        {item.ItemName}
                        {item.VariationName ? `(${item.VariationName})` : ""}
                      </h6>
                      <div>
                        Unit Price: {parseFloat(item.UnitPrice).toFixed(2)} |
                        Qty: {parseInt(item.itemquantity)} <br />
                        Categories: {item.CategoryName}
                      </div>
                      {/* Add any other customer details here */}
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          ""
        )}
      </form>
    </div>
  );
};
// SearchableDropdown

export default FeaturedProducts;
